<script>
  import { width, height, startPageState, loadedObjects } from "./stores";
  import { fade } from "svelte/transition";

  function changeStartPageState() {
    startPageState.set(false);
  }
</script>

<div class="container" style="width: {$width}px; height:{$height}px;">
<div class="text">
<h1>(hn)</h1>
<!-- <div id="loading" style="width: {$loadedPercentage}px; height: 5px; background: cyan;"></div> -->
<!-- <p>{$loadedObjects} / 8</p> -->
<p>Born in the city.</p>
{#if $loadedObjects >= 6}
<button class="button" on:click={changeStartPageState} in:fade><h3>Перейти в show-room</h3></button>
{:else}
<p style="color: #c4e1ff;" in:fade>Loading... ({$loadedObjects}/6)</p>
{/if}
<br>
<div class="instruction">
<h3>Как исследовать шоурум</h3>
<p>- используй стрелки для перемещения. 
<br>- зажми и передвигай курсор, чтобы осмотреться.
<br>- кликай на <b><span style="font-family: TTHoves, sans-serif; font-size: 25px;">+</span></b>, чтобы узнать подробности. 
</p>
</div>
</div>
</div>

<style>
  .container {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(80px);
    -webkit-backdrop-filter: blur(40px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    z-index: 20;
  }
  .text {
    width: min(90%, 400px);
    height: min(100%, 500px);
    text-align: left;
    font-family: PPFormula, sans-serif;
    font-size: 16px;
  }
  .text h1 {
    font-family: PPFormula Bold, sans-serif;
  }
  .instruction {
    border: 1px solid black;
    padding: 0 20px 20px 20px;
    font-family: PPFormula, sans-serif;
    font-size: 16px;
  }
  .button {
    width: 100%;
    height: 60px;
    margin-top: 20px;
    background: black;
    border: 1px solid black;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 5px 5px 0 #c4e1ff;
    text-align: left;
    cursor: pointer;
    padding-left: 20px;
  }
  .button:hover {
    background: rgba(255, 255, 255, 0.5);
    color: black;
  }
</style>